import { ArticleCard, StoryCard } from '@vfit/shared/components';
import { IStoryDataContent, IStorySize } from './StoryDataContent.models';

const StoryDataContent = (
  storiesAndArticles: IStoryDataContent[],
  size?: IStorySize
): JSX.Element[] => {
  const getElement = (element: JSX.Element) => {
    if (size?.width && size.height) {
      return (
        <div
          style={{
            width: size.width,
            height: size.height,
          }}
        >
          {element}
        </div>
      );
    }
    return element;
  };
  return storiesAndArticles.map((el: IStoryDataContent): JSX.Element => {
    if (el?.type === 'story') {
      return getElement(<StoryCard ignoreSize={!!size} {...el} isExternalImages />);
    }
    return getElement(<ArticleCard ignoreSize={!!size} {...el} isExternalImages />);
  });
};

export default StoryDataContent;
